import * as React from 'react'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import { FC } from 'react'
import { IconButton, Toolbar, Button, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { useTranslation } from 'react-i18next'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />
})

export interface ModalProps extends DialogProps {
  open: boolean
  setOpen?: any
  title: string
  children: React.ReactNode
  actions?: any
  onClose?: any
  onConfirm?: () => void
  onDismiss?: () => void
  loading?: boolean
  dismissButtonTitle?: string
  confirmButtonTitle?: string
}

const Modal: FC<ModalProps> = (props) => {
  const {
    open,
    setOpen,
    title,
    children,
    actions,
    onClose,
    loading,
    onConfirm,
    dismissButtonTitle,
    confirmButtonTitle,
    ...rest
  } = props

  const { t } = useTranslation()

  const handleClose = () => {
    setOpen(false)
    onClose()
  }

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        TransitionComponent={Transition}
        keepMounted
        {...rest}
      >
        <Toolbar>
          <Typography variant="h5" sx={{ bgColor: 'none', flex: 1, p: 0 }}>
            {title}
          </Typography>
          <IconButton autoFocus color="inherit" onClick={handleClose}>
            <Close />
          </IconButton>
        </Toolbar>
        <DialogContent sx={{ p: 3 }}>{children}</DialogContent>

        <DialogActions sx={{ p: 3, pt: 0 }}>
          {actions ? (
            <>{actions}</>
          ) : (
            <>
              <Button size="medium" variant="outlined" onClick={handleClose}>
                {dismissButtonTitle || t('close')}
              </Button>
              <LoadingButton
                size="medium"
                variant="contained"
                loading={loading}
                onClick={onConfirm}
              >
                {confirmButtonTitle || t('save')}
              </LoadingButton>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default Modal
